// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__9REtb","title":"InfoRow_title__2nHIl"};